import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import atualizarPessoa from '../../actions/pessoa/atualizarPessoa';
import {    
    renderFieldText,
    renderFieldTelefone,
    required,    
    telefone,
    renderFieldNumber
} from '../../util/inputs'
import { showSuccessMsg } from '../../util/messagesUtil';

const selector = formValueSelector('formularioCadastroEncomenda');

export class AtualizarCadastroPessoa extends Component {

    atualizar(values) {
        const parametros = {
            nome: values.nome,            
            telefone: values.telefone,
            id: this.props.pessoa.id,
            inscricaoEstadual: values.ie
        };
        this.props.atualizarPessoa(parametros).then(() => {
            this.props.habilitarDesabilitarBotao(false);
            showSuccessMsg('Pessoa atualizada com sucesso');
            this.props.buscarPessoa(this.props.pessoa.cpfCnpj);
        })
    }

    render() {
        const { handleSubmit, submitting, invalid, pristine } = this.props;
        return (
            <div>
                <form onSubmit={handleSubmit(this.atualizar.bind(this))}>
                    <div className="form-group">
                        <Field name="nome" type="text" validate={[required]} required={true}
                            component={renderFieldText} label="Nome Completo:"
                            css="form-control col-md-6" readOnly={false}
                        />
                    </div>                    
                    <div className="form-group">
                        <Field name="telefone" type="text" validate={[required, telefone]}
                            component={renderFieldTelefone}
                            css="form-control col-md-6" label="Telefone"
                        />
                    </div>
                    {this.props.pessoa.tipoPessoa == 'PJ' ? <div className="form-group">
                        <Field name="ie" type="text" component={renderFieldNumber} formatacao="##############"                                
                                label="Inscrição Estadual:"
                                css="form-control col-md-6" readOnly={false}/>
                    </div>: ''}
                    <button id='cancelar' type="button" className="btn btn-danger mr-2"
                        onClick={() => this.props.habilitarDesabilitarBotao(false)}>
                        Cancelar
                    </button>
                    <button type="submit" disabled={invalid || submitting || pristine}
                        className="btn btn-laranja">Salvar
                    </button>
                </form>
            </div>
        )
    }
}

export const mapStateToProps = state => (
    {
        nome: selector(state, 'nome'),        
        telefone: selector(state, 'telefone'),
        ie: selector(state, 'ie')
    });

export default connect(mapStateToProps, { atualizarPessoa })(reduxForm({
    form: 'formularioAtualizarCadastroPessoa'
})(AtualizarCadastroPessoa));